<template>
  <div>
    <el-dialog
      :title="dialogOption.title"
      :visible.sync="dialogOption.dialogVisible"
      :before-close="close"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form ref="form" :model="formData" :rules="rules" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_2_label_category')||'产品主分类'" prop="categoryCode">
              <dict-select style="width: 100%;"
                           v-model="formData.categoryCode"
                           url="/digitalCenter/common/dict/masterCategory"
                           size="medium"
                           :placeholder="$l('form_2_label_category')||'产品主分类'"
                           filterable
                           clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_2_label_price_range')||'价格范围'" prop="priceRange">
              <el-input v-model="formData.priceRange" size="medium" :placeholder="$l('form_2_label_price_range')||'价格范围'" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_2_label_spec')||'产品规格'" prop="spec">
              <el-input v-model="formData.spec" size="medium" :placeholder="$l('form_2_label_spec')||'产品规格'" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_2_label_testing_protocol')||'测试规则'" prop="testingProtocol">
              <el-input v-model="formData.testingProtocol" size="medium" :placeholder="$l('form_2_label_testing_protocol')||'测试规则'" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_2_label_moq')||'最低起订量'" prop="moq">
              <el-input v-model="formData.moq" size="medium" :placeholder="$l('form_2_label_moq')||'最低起订量'" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_2_label_style')||'款式'" prop="styles">
              <el-input v-model="formData.styles" size="medium" :placeholder="$l('form_2_label_style')||'款式'" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="formData.custLabelCode">
            <div style="font-size: 14px; color: #606266;">
              <span>Create：{{formData.createByName}} at {{formData.createDate}}</span>
            </div>
            <div style="font-size: 14px; color: #606266;">
              <span>Modify：{{formData.modifyByName}} at {{formData.modifyDate}}</span>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" size="small">{{$l('form_2_btn_cancel') || '取消'}}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
        >{{$l('form_2_btn_save') || '保存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    params: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      dialogOption: {
        title: '新增',
        dialogVisible: false,
      },
      formData: {
        custLabelCode: '', // 选项编码
        custCode: '', // 客户内码
        categoryCode: '', // 分类内码
        priceRange: '', // 价格范围
        spec: '', // 产品规格
        testingProtocol: '', // 测试规则
        moq: '', // 最低起订量
        styles: '', // 款式
        companyCode: '', // 商户内码
        createByName: '',
        createDate: '',
        modifyDate: '',
        modifyByName: ''
      },
      rules: {
        categoryCode: [
          { required: true, message: this.$l('form_2_tips_select_category')||'请选择产品主分类', trigger: "change" },
        ]
      }
    }
  },
  methods: {
    load(ref, val) {
      if(ref === 'add') {
        this.dialogOption.title = this.$l('form_2_title_add') || '新增'
      }else if(ref === 'edit') {
        this.dialogOption.title = this.$l('form_2_title_edit') || '编辑'
        this.getData(val)
      }
      this.dialogOption.dialogVisible = true
    },
    getData(val){
      this.$api.customerLabelsDetail({custLabelCode: val}).then((res) => {
        this.formData = res.body
      })
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.params && this.params.custCode) {
            this.formData.custCode = this.params.custCode
          }
          this.$api.customerLabelsSave(this.formData).then(() => {
            this.$message({
              showClose: true,
              message: this.$l('tips_save_ok')||'保存成功',
              type: "success",
            })
            this.close()
            // 通知父组件保存成功
            this.$emit("success")
          })
        } else {
          return false;
        }
      })
    },
    close() {
      this.formData.custLabelCode = ""
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.dialogOption.dialogVisible = false;
    },
    reset() {
      this.formData.custLabelCode = ""
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    }
  }
}
</script>
